import {createReducer} from '@reduxjs/toolkit';

import {setDataFromHostStore} from '../../actions';
import {getQuote, removeQuoteItem} from '../quoteItems/quoteItems';

const initialState = 0;

/**
 * Get cart quotes count
 *
 * @param {number} state - Current state
 * @param {ActionType<AxiosPromise>} action - Received action
 * @returns {number} updated cart quotes count
 */
export const quoteItemsCount = createReducer<number>(initialState, builder =>
    builder
        .addCase(setDataFromHostStore, (state, action) => action.payload?.count || state)
        .addCase(getQuote.fulfilled, (_, action) => action.payload?.data.count)
        .addCase(getQuote.rejected, () => 0)
        .addCase(removeQuoteItem.pending, state => state - 1)
        .addCase(removeQuoteItem.fulfilled, (_, action) => action?.payload?.data.count),
);
